import Scrollbar from './src/main';

/* istanbul ignore next */
Scrollbar.install = function (Vue) {
  Vue.component(Scrollbar.name, Scrollbar);
};

export default Scrollbar;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/element-ui/packages/scrollbar/index.js